import { MapPin, Languages } from "lucide-react";

export function FounderAvatar({ compact = false }) {
  return (
    <div className={`relative mx-auto w-full ${compact ? "max-w-xs" : "max-w-md"}`} data-testid="founder-avatar">
      <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-br from-teal-200/60 via-sky-100 to-transparent blur-2xl" />
      <div className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_40px_80px_-40px_rgba(15,23,42,0.35)]">
        <svg viewBox="0 0 400 440" className="block w-full" role="img" aria-label="Leila SID – illustration">
          <defs>
            <linearGradient id="fa-bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#E0F2FE" /><stop offset="1" stopColor="#CCFBF1" /></linearGradient>
            <linearGradient id="fa-body" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#0F172A" /><stop offset="1" stopColor="#1E293B" /></linearGradient>
            <linearGradient id="fa-ring" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#0284C7" /><stop offset="1" stopColor="#0D9488" /></linearGradient>
          </defs>
          <rect width="400" height="440" fill="url(#fa-bg)" />
          <circle cx="200" cy="200" r="150" fill="none" stroke="url(#fa-ring)" strokeWidth="2" strokeDasharray="6 10" opacity="0.6" />
          <circle cx="200" cy="200" r="120" fill="#fff" opacity="0.7" />
          <path d="M80 440c0-80 55-130 120-130s120 50 120 130" fill="url(#fa-body)" />
          <path d="M150 330c15 25 35 40 50 40s35-15 50-40" fill="none" stroke="#0D9488" strokeWidth="6" strokeLinecap="round" />
          <circle cx="200" cy="200" r="70" fill="#F5D0B5" />
          <path d="M125 205c-5-60 30-100 75-100s80 40 75 100c-8-40-30-55-75-55s-67 15-75 55z" fill="#1F2937" />
          <path d="M120 215c-10 40 5 80 20 95 5-35 0-70-20-95zM280 215c10 40-5 80-20 95-5-35 0-70 20-95z" fill="#1F2937" />
          <circle cx="175" cy="205" r="5" fill="#0F172A" />
          <circle cx="225" cy="205" r="5" fill="#0F172A" />
          <path d="M185 240q15 12 30 0" fill="none" stroke="#0F172A" strokeWidth="3.5" strokeLinecap="round" />
          <circle cx="330" cy="90" r="6" fill="#0D9488" />
          <circle cx="60" cy="330" r="4" fill="#0284C7" />
          <path d="M320 340l10 10 18-22" fill="none" stroke="#0D9488" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <div className="flex items-center justify-between border-t border-slate-100 bg-white px-6 py-4">
          <div>
            <p className="font-display text-base font-bold text-slate-900">Leila SID</p>
            <p className="text-xs text-slate-500">SIDLY · Entrepreneur individuel</p>
          </div>
          <div className="flex gap-2 text-slate-500">
            <span className="flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs"><MapPin size={12} /> Bagnolet</span>
            <span className="flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs"><Languages size={12} /> FR/EN</span>
          </div>
        </div>
      </div>
    </div>
  );
}
